var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('shell',{attrs:{"banner":_vm.banner,"shell_input":_vm.send_to_terminal,"commands":_vm.commands},on:{"shell_output":_vm.prompt}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }